import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isStaffUser } from '../utils/auth';

// This is used to determine if a user is authenticated and
// if they are staff

// If they are: they proceed to the page
// If not: they are redirected to the login page.
const StaffRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        isStaffUser() ? <Component {...props} /> : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      }
    />
  );
};

export default StaffRoute;
